import { AdminClientTribesReports  } from './AdminClientTribesReports';

export default AdminClientTribesReports;